import React from 'react';
import styled from 'styled-components/macro';
import { Panel } from './Panel';

type Props = {
  count?: number;
  className?: string;
};

export const Panels = (props: Props) => {
  const { count = 3, className } = props;

  return (
    <PanelsWrap className={className}>
      {[...Array(count)].map((elem, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <Panel key={i} width={100} />
      ))}
    </PanelsWrap>
  );
};

const PanelsWrap = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 991px) {
    flex-direction: column;
  }
`;
